import type { FlexiForwardTcResponse } from '@/store/flexi-forward/api/trade-capture/checkFlexiForward.ts';
import type {
  FlexiForwardProperties,
  FlexiForwardTradeCaptureError,
  FxFlexiForward,
} from '@/store/flexi-forward/state.ts';
import type { TradeCapture } from '@/store/types.ts';

export function updateFlexiForwardFromTradeCapture(
  currentFlexiForward: FxFlexiForward,
  flexiForwardFromTradeCapture: FlexiForwardTcResponse,
): FxFlexiForward {
  const tradeCapture = {
    ...flexiForwardFromTradeCapture.tradeCapture,
  } satisfies TradeCapture<FlexiForwardProperties, FlexiForwardTradeCaptureError>;

  return {
    type: 'FxFlexiForward',
    properties: updatePropertiesFromTradeCapture(currentFlexiForward, flexiForwardFromTradeCapture),
    tradeCapture,
    clientId: currentFlexiForward.clientId,
    // executionId: undefined,
  };
}

function updatePropertiesFromTradeCapture(
  currentFlexiForward: FxFlexiForward,
  flexiForwardFromTradeCapture: FlexiForwardTcResponse,
): FxFlexiForward['properties'] {
  if (flexiForwardFromTradeCapture.type === 'error') {
    // In case of error, we want to keep the previous properties to avoid losing data that the user might have entered
    return getPreviousFlexiForwardProperties(currentFlexiForward);
  }

  const previousProperties = getPreviousFlexiForwardProperties(currentFlexiForward);
  const updatedProperties = flexiForwardFromTradeCapture.properties;

  return {
    ...previousProperties,
    ...updatedProperties,
  };
}

function getPreviousFlexiForwardProperties(currentFlexiForward: FxFlexiForward): FlexiForwardProperties {
  return currentFlexiForward.properties;
}
